import { DOCUMENT, NgClass } from '@angular/common';
import { Component, OnInit, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { ImpersonationService } from 'src/app/services/impersonation/impersonation.service';
import { FCMService } from 'src/app/services/notifications/fcm.service';
import { RealtimeService } from 'src/app/services/realtime/realtime.service';
import { AICoreStateModule } from 'src/app/store/aicore/aicore.state.module';
import { LoadActiveIncidentCount } from 'src/app/store/incident-activity/incident-activity.actions';
import { StatuspagesStateModule } from 'src/app/store/statuspages/statuspages.state.module';
import { LoadSubscriptionAction } from 'src/app/store/subscription/subscription.actions';
import { LoadUserAction } from 'src/app/store/user/user.actions';
import { ImpersonationBannerComponent } from '../../layout/impersonation-banner/impersonation-banner.component';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { TopbarComponent } from '../../layout/topbar/topbar.component';
import { TrialBannerComponent } from '../../layout/trial-banner/trial-banner.component';
import { WelcomeRevealService } from 'src/app/services/onboarding/welcome-reveal.service';
import { WelcomeRevealComponent } from './components/welcome-reveal/welcome-reveal.component';
import { loaderPose } from './components/welcome-reveal/loader-pose';
import { welcomeShellVariants } from './components/welcome-reveal/welcome-reveal.variants';
import { fromEvent, map } from 'rxjs';

@Component({
  selector: 'app-layout-dashboard',
  templateUrl: './internal.component.html',
  imports: [
    SidebarComponent,
    TopbarComponent,
    ImpersonationBannerComponent,
    WelcomeRevealComponent,
    TrialBannerComponent,
    NgClass,
    RouterOutlet,
    StatuspagesStateModule,
    AICoreStateModule,
  ],
})
export class InternalLayoutComponent implements OnInit {
  rt = inject(RealtimeService);
  fcm = inject(FCMService);

  private store = inject(Store);
  // the impersonation frame overlays the viewport edge; keep the app inside it
  protected impersonating = inject(ImpersonationService).active;

  private readonly welcomeReveal = inject(WelcomeRevealService);

  protected readonly shellClasses = computed(() =>
    welcomeShellVariants({ phase: this.welcomeReveal.phase() ?? 'none' })
  );

  private readonly window = inject(DOCUMENT).defaultView!;

  private readonly viewport = toSignal(
    fromEvent(this.window, 'resize').pipe(map(() => this.viewportSize())),
    { initialValue: this.viewportSize() }
  );

  /** Where the welcome reveal shows the dashboard, for this window. */
  protected readonly previewPose = computed(() =>
    loaderPose(this.viewport().width, this.viewport().height)
  );

  private viewportSize(): { width: number; height: number } {
    return { width: this.window.innerWidth, height: this.window.innerHeight };
  }

  ngOnInit(): void {
    this.store.dispatch(new LoadUserAction());
    this.store.dispatch(new LoadSubscriptionAction());
    this.store.dispatch(new LoadActiveIncidentCount());
  }
}
